import styled from "styled-components";
export const AppLayoutContainer = styled.div`
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    &::-webkit-scrollbar-track {
        border: 1px solid #000;
        padding: 5px;
        background-color: transparent;
    }

    &::-webkit-scrollbar {
        width: 7px;
        
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        box-shadow: inset 0 0 6px rgba(0,0,0,.3);
        background-color: rgba(255,255,255,0.2);
        border: 1px solid #000;
    }
`

export const AuthContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`
export const LogoContainer = styled.div`
    text-align: center;
    margin-bottom: 2em;
`
export const AppHeaderWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: none;
        
    }
`
export const AppHeaderLogoContainer = styled.div`
    display: flex;
    justify-content: start;
    align-items: center;
    gap: .5em;
    & img{
        height: 30px;
        margin: 0;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        height: 100%;
        padding: .5em 1em;
    }
`
export const AuthWrapper = styled.div`
    width: 100%;
    min-width: 400px;
    max-width: 500px;
`
export const Card = styled.div`
    width: 100%;
    padding: 2em;
    border: 2px solid var(--card-border-color);
    background: var(--card-background-color);
    border-radius: 20px;
    margin: 1em 0;
    box-shadow: 0px 0px 5px var(--card-border-color);
`

export const LogoImage = styled.img`
    height: 40px;
    margin-bottom: .3em;
`
export const LogoImageText = styled.div`
    margin-bottom: 1em;
    font-family: montserrat, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    text-align: center;
    text-transform: none;
    letter-spacing: -.04em;
    color: #e5e5e5;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: 100%;
    -moz-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    width: 100%;
    line-height: 100%;
    
`
export const AdminLayout = styled.div`
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: var(--sidebar-width) 1fr;
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: block;
    }
    
`
export const MainContent = styled.div`
    padding: 1em;
    transition: all ease-in-out .3s;
    margin-left: ${({ $isShowSideBar }) => !$isShowSideBar?`calc(var(--sidebar-width) * -1)`:`0px`};
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        margin-left: 0;
    }
    
`
export const AppHeader = styled.div`
    width: 100%;
    height: 60px;
    background: var(--header-background-color);
    box-shadow: 0px 0px 4px #000;
    display: grid;
    grid-template-columns: var(--sidebar-width) 1fr;
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: block;
    }
`
export const AppMain = styled.div`
    width: 100%;
    height: 100%;
`
export const AppHeaderMenuIcon = styled.div`
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #b7b7b7;
    border-radius: 50%;
    cursor: pointer;
    transition: all ease-in-out .3s;
    &:hover{
        transition: all ease-in-out .3s;
        color: var(--primary-color);
        border-color: var(--primary-color);
    }
    & svg{
        font-size: 26px;
    }
    &.active{
        transition: all ease-in-out .3s;
        color: var(--primary-color);
        border-color: var(--primary-color);
    }
`
export const AppHeaderTitle = styled.div`
    padding: 0 1em;
    font-weight: bold;
    font-size: 1.1em;
`
export const LogoutButton = styled.button`
    background: rgba(255, 255, 255, .15);
    border: none;
    padding: .7em .7em;
    display: flex;
    font-size: 20px;
    justify-content: center;
    align-items: center;
    color: #fff;
    border-radius: 10px;
    transition: all ease-in-out .3s;
    &:hover{
        background: rgba(255, 255, 255, .1);
        color: #ff3737;
        transition: all ease-in-out .3s;
    }
`
export const AppHeaderTools = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: .3em;
    padding: 0 .3em;
`
export const AppHeaderProfile = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: .5em;
    padding: .5em;
    background: rgba(255,255,255,.1);
    border-radius: 15px;
    margin-bottom: 1em;
`
export const AppHeaderProfileAvatar = styled.div`
    width: 48px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background: #fff;
    color: rgba(0, 0, 0, 0.5);
    font-size: 24px;
}
`
export const AppHeaderProfileInfo = styled.div`
    flex: 1;
    h4{
        font-size: 1.2em;
        margin-bottom: 0.3em;
    }
    h5{
        font-size: 1em;
        margin-bottom: 0;
    }
`